import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import SurveyPage from '../views/SurveyPage.vue'
import ReviewPage from '../views/ReviewPage.vue'
import AboutAecomPage from '../views/AboutAecomPage.vue'
import PrivacyPage from '../views/PrivacyPage.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/survey',
    name: 'Survey',
    component: SurveyPage
  },
  {
    path: '/review',
    name: 'Review',
    component: ReviewPage
  },
  {
    path: '/about-aecom',
    name: 'AboutAecom',
    component: AboutAecomPage
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: PrivacyPage
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { left: 0, top: 0 };
    }
  }
})

export default router
